
export default {
  // Step wizard keys
  informationStep: "معلومات",
  locationStep: "الموقع",
  timeStep: "التاريخ",
  contentStep: "المحتوى",
  accountStep: "الحساب",
  paymentStep: "الدفع",
  submitCampaign: "إرسال الحملة",
  next: "التالي",
  back: "السابق",
  selectLocationDesc: "حدد المواقع لحملتك الإعلانية",
  selectDurationDesc: "حدد المدة التي ترغب في عرض حملتك الإعلانية فيها",
  uploadCreativesDesc: "قم بتحميل المواد الإبداعية لحملتك الإعلانية",
  enterAccountInfoDesc: "أدخل معلومات الشركة وبيانات الاتصال",
  reviewCampaignDesc: "راجع تفاصيل حملتك",
  information: "معلومات",
  locations: "المواقع",
  time: "الوقت",
  content: "المحتوى",
  payment: "الدفع",
  clickToReturn: "انقر للعودة",
  reviewAndPayment: "المراجعة والدفع",
  proceedToPayment: "المتابعة للدفع",
  processing: "معالجة...",
  viewInvoice: "عرض الفاتورة",
  creatingCampaign: "إنشاء الحملة...",
  createNewCampaign: "إنشاء حملة جديدة",
  Error: "خطأ",
  submissionError: "خطأ في الإرسال",
  submissionInProgress: "الإرسال قيد المعالجة...",
  clickAgain: "انقر مرة أخرى لتأكيد الإرسال",
  
  campaignStart: "تاريخ البداية",
  campaignEnd: "تاريخ النهاية",
  
  // Terms and Conditions
  termsTitle: "الشروط والأحكام",
  cancel: "إلغاء",
  acceptAndProceed: "موافقة ومتابعة",
} as const;
